if (!customElements.get('product-background')) {
  customElements.define(
    'product-background',
    class ProductBackground extends window.BAO.CustomElement {
      constructor () {
        super()

        this.isTicking = false

        this.setupListeners()

        this.requestTick = this.requestTick.bind(this)
        this.setBackgroundHeight = this.setBackgroundHeight.bind(this)
      }

      setupListeners () {
        window.addEventListener('scroll', () => this.setBackgroundHeight())
        window.addEventListener('resize', () => this.setBackgroundHeight())

        document.addEventListener('DOMContentLoaded', () =>
          this.setBackgroundHeight()
        )
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.setBackgroundHeight)

        this.isTicking = true
      }

      setBackgroundHeight () {
        const productNavSectionEl = window.BAO.utils.getElement(
          '.prd-Navigation'
        )

        if (!productNavSectionEl) return

        const navOffset = window.BAO.utils.getOffsetTop(productNavSectionEl)

        this.style.setProperty('--NavOffset', `${navOffset}px`)
      }
    }
  )
}
